// accordion
function accordionDropdown() {
    var accoordionContainer = document.querySelectorAll('.accordion');

    accoordionContainer.forEach((eachAccordion)=> {
        const accordionBtns = eachAccordion.querySelectorAll(".accordion__button");

        accordionBtns.forEach((accordion) => {
        accordion.onclick = function () {
            this.classList.toggle("is-open");
        
            let content = this.nextElementSibling;
            console.log(content);
        
            if (content.style.maxHeight) {
            //this is if the accordion is open
            content.style.maxHeight = null;
            } else {
            //if the accordion is currently closed
            content.style.maxHeight = content.scrollHeight + "px";
            console.log(content.style.maxHeight);
            }
        };
        });
    });
}

accordionDropdown()